"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var certification_watermark_1 = require("@tableau/certification-watermark");
var Localize_1 = require("../../gen-src/Localize");
var UserDisplayComponent_1 = require("./UserDisplayComponent");
/**
 * Converts a user into the "certifier props" for the certification widget.
 * In some cases (e.g. the Connect To dialog), linking is disabled, so if SiteUrls is not passed in,
 * it will not include the URL prop, allowing the widget to render the certifier's name as static text.
 * Inactive users will also be rendered as static text, because they don't have a URL.
 * @param certifier
 * @param siteUrls
 */
function getCertifierPropsFromCertifier(certifier, siteUrls) {
    if (!UserDisplayComponent_1.isUserInfoVisible(certifier)) {
        return {
            customUserStyle: UserDisplayComponent_1.UserPlaceholderStyle,
            displayName: Localize_1.Messages.HiddenUser(),
        };
    }
    else if (!UserDisplayComponent_1.isUserActive(certifier)) {
        return {
            displayName: UserDisplayComponent_1.getUserNameForDisplay(certifier),
        };
    }
    else {
        return {
            url: siteUrls ? UserDisplayComponent_1.getUserUrlForDisplay(siteUrls, certifier) : undefined,
            displayName: UserDisplayComponent_1.getUserNameForDisplay(certifier),
        };
    }
}
exports.getCertifierPropsFromCertifier = getCertifierPropsFromCertifier;
/**
 * Displays a certification icon, which can then be clicked to launch a tooltip giving more details.
 * If the item is not certified, will render null.
 * @param props
 */
function CertificationWidget(props) {
    var certifier = props.certification.certifier;
    if (!props.certification.isCertified || !certifier) {
        return null;
    }
    return (React.createElement(certification_watermark_1.CertificationTooltipComponent, { id: props.contentId, icon: props.icon, note: props.certification.certificationNote || '', certifier: getCertifierPropsFromCertifier(certifier, props.siteUrls), className: props.className, showExtractRefresh: props.showExtractRefresh }));
}
exports.CertificationWidget = CertificationWidget;
//# sourceMappingURL=CertificationWidget.js.map